import {Nullable} from '../../app/TypeHelpers'

export default class EquipmentForAdmin {
    id: number
    name: string
    parentEquipmentName: Nullable<string>
    reservationCountMonthly: Nullable<number>
    reservationCountDaily: Nullable<number>
    lotteryEntryCountMonthly: Nullable<number>
    updateDatetime: string

    constructor(
        id: number,
        name: string,
        parentEquipmentName: Nullable<string>,
        reservationCountMonthly: Nullable<number>,
        reservationCountDaily: Nullable<number>,
        lotteryEntryCountMonthly: Nullable<number>,
        updateDatetime: string,
    ) {
        this.id = id
        this.name = name
        this.parentEquipmentName = parentEquipmentName
        this.reservationCountMonthly = reservationCountMonthly
        this.reservationCountDaily = reservationCountDaily
        this.lotteryEntryCountMonthly = lotteryEntryCountMonthly
        this.updateDatetime = updateDatetime
    }

    static from(json: any): EquipmentForAdmin {
        return new EquipmentForAdmin(
            json.id,
            json.name,
            json.parentEquipmentName,
            json.reservationCountMonthly,
            json.reservationCountDaily,
            json.lotteryEntryCountMonthly,
            json.updateDatetime,
        )
    }
}
